var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-resource-helper-components-1-main-page"},[_c('div',[_c('ProductResourceHelperComponents2Header',{attrs:{"productResourceId":_vm.productResourceId}}),_c('ProductResourceHelperComponents3ResourceList')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }